<template>
  <div class="flex justify-between leading-4 mb-3">
    <div class="flex font-semibold">
      <label :for="name">{{ label }}</label>
      <span v-if="required" class="ml-2 flex-shrink-0 text-coral-main text-xs">
        必須
      </span>
    </div>

    <span v-if="note" class="text-xs font-light text-gray-62 leading-4">
      {{ note }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    note: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  setup() {},
};
</script>

<style lang="scss" scoped></style>
